// test2241
(2241 && 0);
